export function reportCsvRows(content: string) {
  const source = content.replace(/^\uFEFF/, "").replace(/\r\n?/g, "\n")
  const rows: string[][] = []
  let row: string[] = []
  let cell = ""
  let quoted = false
  for (let index = 0; index < source.length; index++) {
    const char = source[index]
    if (char === '"' && quoted && source[index + 1] === '"') { cell += '"'; index++; continue }
    if (char === '"' && (quoted || !cell)) { quoted = !quoted; continue }
    if (!quoted && (char === "," || char === "\n")) {
      row.push(cell)
      cell = ""
      if (char === "\n") { if (row.some((value) => value.length)) rows.push(row); row = [] }
      continue
    }
    cell += char
  }
  row.push(cell)
  if (row.some((value) => value.length)) rows.push(row)
  return rows
}

// Plain text and CSV values remain text nodes, including cells containing HTML.
export function printableReport(title: string, format: string, content: string) {
  if (/^(html|htm|text\/html)$/.test(format)) return content
  const doc = new DOMParser().parseFromString("<!doctype html><html><head></head><body></body></html>", "text/html")
  doc.title = title
  const heading = doc.createElement("h1")
  heading.textContent = title
  doc.body.append(heading)
  const style = doc.createElement("style")
  style.textContent = "body{font:14px/1.6 system-ui;color:#222;padding:24px}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ddd;padding:8px;text-align:left;white-space:pre-wrap}pre{white-space:pre-wrap;overflow-wrap:anywhere}thead{display:table-header-group}tr{break-inside:avoid}@media print{body{padding:0}}"
  doc.head.append(style)
  if (format === "csv") {
    const table = doc.createElement("table")
    const head = doc.createElement("thead")
    const body = doc.createElement("tbody")
    reportCsvRows(content).forEach((row, index) => {
      const tr = doc.createElement("tr")
      row.forEach((value) => { const cell = doc.createElement(index ? "td" : "th"); cell.textContent = value; tr.append(cell) })
      ;(index ? body : head).append(tr)
    })
    table.append(head, body)
    doc.body.append(table)
  } else {
    const pre = doc.createElement("pre")
    pre.textContent = content
    doc.body.append(pre)
  }
  return `<!doctype html>\n${doc.documentElement.outerHTML}`
}
